import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import mainpage from '@/components/mainpage'
import structureview from '@/components/structureview'
import test0 from '@/components/test'
import structure from '@/components/structure'
// import structureedit from '@/components/structureedit'
import singlefile from '@/components/singlefile'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'view0',
      component: mainpage
    },
    {
      path: '/view',
      name: 'view',
      component: structureview
    },
    {
      path: '/test',
      name: 'test',
      component: test0
    },
    {
      path: '/structure/:id',
      name: 'structure',
      component: structure
    },
    // {
    //   path: '/structureedit/:id',
    //   name: 'structureedit',
    //   component: structureedit
    // },
    {
      path: '/singlefile',
      name: 'singlefile',
      component: singlefile
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js